<template>
  <div ref="cookiePolicyContainer" id="cookie-policy-container" class="mdl-grid slide-in-bottom">
    <div class="mdl-cell mdl-cell--3-col mdl-cell--1-col-tablet"></div>
    <div class="mdl-cell mdl-cell--6-col mdl-cell--5-col-tablet mdl-cell--3-col-phone">
      <i18n class="cookie-policy" path="cookieBannerMsg">
        <a :href="termsOfServiceLink">{{ $t('termsOfService') }}</a>
        <a :href="privacyPolicyLink">{{ $t('privacyPolicy') }}</a>
        <a :href="cookiePolicyLink">{{ $t('cookiePolicy') }}</a>
      </i18n>

      <br/>
      <div class="mdc-checkbox">
        <input type="checkbox" class="mdc-checkbox__native-control" id="analyticsCookiesAllowed" v-model="isAnalyticsEnabled"/>
        <div class="mdc-checkbox__background">
          <svg class="mdc-checkbox__checkmark"
              viewBox="0 0 24 24">
            <path class="mdc-checkbox__checkmark-path"
                  fill="none"
                  d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
          </svg>
          <div class="mdc-checkbox__mixedmark"></div>
        </div>
        <label for="analyticsCookiesAllowed">{{ $t('allowAnalytics') }}</label>
      </div>

      <p class="analyticsDesc">{{ $t('analyticsDescription') }}</p>
      <button id="cookieBannerCloseButton" @click="closeCookieBanner">{{ $t('OKAction') }}</button>
    </div>
    <div class="mdl-cell mdl-cell--3-col mdl-cell--2-col-tablet"></div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueI18n from 'vue-i18n'

  const messages = {
    en: {
      cookieBannerMsg: 'By using this site, you acknowledge that you have read and understood our {0}, {1} and {2}.',
      termsOfService: 'terms of service',
      privacyPolicy: 'privacy policy',
      cookiePolicy: 'cookie policy',
      allowAnalytics: 'Allow analytics cookies',
      OKAction: 'OK',
      analyticsDescription: '(We use analytics cookies to collect anonymous usage data to improve Pollscape)'
    },
    hi: {
      cookieBannerMsg: 'इस साइट का उपयोग करके, आप स्वीकार करते हैं कि आपने हमारी {0}, {1} और {2} को पढ़ और समझ लिया है।',
      termsOfService: 'सेवा की शर्तें',
      privacyPolicy: 'गोपनीयता नीति',
      cookiePolicy: 'कुकी नीति',
      allowAnalytics: 'एनालिटिक्स कुकीज़ की अनुमति दें',
      OKAction: 'ठीक हैं',
      analyticsDescription: '(पोलस्केप को बेहतर बनाने के लिए हम अनाम उपयोग डेटा एकत्र करने के लिए एनालिटिक्स कुकीज़ का उपयोग करते हैं)'
    }
  }

  Vue.use(VueI18n)

  const i18n = new VueI18n({
    locale: typeof (Storage) !== 'undefined' ? localStorage.getItem('userLang') ? localStorage.getItem('userLang') : 'en' : 'en',
    messages: messages
  })

  export default {
    i18n,
    data () {
      return {
        termsOfServiceLink: '/terms-of-service',
        cookiePolicyLink: '/cookiePolicy',
        privacyPolicyLink: '/privacyPolicy',
        isAnalyticsEnabled: true
      }
    },
    props: {
      userLang: {
        type: String,
        default: 'en'
      }
    },
    methods: {
      closeCookieBanner () {
        this.isAnalyticsEnabled ? window.enableAnalytics() : window.disableAnalytics()
        this.$refs.cookiePolicyContainer.classList.add('slide-out-bottom')
        setTimeout(() => {
          this.$refs.cookiePolicyContainer.style.display = 'none'
        }, 500)

        if (typeof (Storage) !== 'undefined') {
          localStorage.setItem('cookiePolicyRead', 'true')
          localStorage.setItem('isAnalyticsEnabled', this.isAnalyticsEnabled.toString())
        }
      }
    },
    mounted () {
      this.$nextTick(function () {
        let cookiePolicyRead = typeof (Storage) !== 'undefined' ? localStorage.getItem('cookiePolicyRead') ? localStorage.getItem('cookiePolicyRead') : 'false' : 'false'
        if (cookiePolicyRead === 'false') {
          this.$refs.cookiePolicyContainer.style.display = 'flex'
        }
      })
    },
    watch: {
      userLang: function (newVal) {
        i18n.locale = newVal
      }
    }
  }
</script>

<style scoped>
  $mdc-theme-secondary: #FF9800;
  @import "@material/checkbox/mdc-checkbox";

  #cookie-policy-container {
    display: none;
    position:fixed;
    padding: 25px;
    bottom: 0;
    width: 100%;
    z-index: 2000;
    background-color: #2d2d2d;
  }

  .cookie-policy {
    float: left;
    color: white;
    margin: 0;
  }

  label {
    padding-left: 10px;
    color: white;
    cursor: pointer;
  }

  input[type=checkbox] {
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }

  .analyticsDesc {
    color: white;
    font-size: 1em;
  }

  @media only screen and (max-width: 600px) {
    .analyticsDesc {
      margin-left: 15%;
    }

    #cookieBannerCloseButton {
      margin-left: 15%;
    }
  }

  @media only screen and (min-width: 600px) and (max-width: 1100px) {
    .analyticsDesc {
      margin-left: 10%;
    }

    #cookieBannerCloseButton {
      margin-left: 10%;
    }
  }

  @media only screen and (min-width: 1100px) {
    .analyticsDesc {
      margin-left: 5%;
    }

    #cookieBannerCloseButton {
      margin-left: 5%;
    }
  }

  #cookieBannerCloseButton {
    color: #FF9800;
    padding: 5px;
    background-color: transparent;
    border: 1px solid #FF9800;
    width: 100%;
    max-width: 150px;
  }

  #cookieBannerCloseButton:hover {
    color: black;
    background-color: #FF9800;
    cursor: pointer;
  }

  #cookieBannerCloseButton:focus {
    color: black;
    background-color: #FF9800;
  }

  .slide-in-bottom {
    -webkit-animation: slide-in-bottom 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
            animation: slide-in-bottom 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  }

  @-webkit-keyframes slide-in-bottom {
    0% {
      -webkit-transform: translateY(1000px);
              transform: translateY(1000px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateY(0);
              transform: translateY(0);
      opacity: 1;
    }
  }
  @keyframes slide-in-bottom {
    0% {
      -webkit-transform: translateY(1000px);
              transform: translateY(1000px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateY(0);
              transform: translateY(0);
      opacity: 1;
    }
  }

  .slide-out-bottom {
    -webkit-animation: slide-out-bottom 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
            animation: slide-out-bottom 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
  }

  @-webkit-keyframes slide-out-bottom {
    0% {
      -webkit-transform: translateY(0);
              transform: translateY(0);
      opacity: 1;
    }
    100% {
      -webkit-transform: translateY(1000px);
              transform: translateY(1000px);
      opacity: 0;
    }
  }
  @keyframes slide-out-bottom {
    0% {
      -webkit-transform: translateY(0);
              transform: translateY(0);
      opacity: 1;
    }
    100% {
      -webkit-transform: translateY(1000px);
              transform: translateY(1000px);
      opacity: 0;
    }
  }

</style>




// WEBPACK FOOTER //
// src/components/CookiePolicyBanner.vue